class QuickAddInline extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this._onClick.bind(this));
  }

  _onClick(e) {
    const btn = e.target.closest('[data-variant-id]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    this._addToCart(btn);
  }

  async _addToCart(btn) {
    if (btn.classList.contains('is-loading')) return;

    btn.classList.add('is-loading');
    btn.disabled = true;

    const formData = new FormData();
    formData.append('id', btn.dataset.variantId);
    formData.append('quantity', 1);

    if (btn.dataset.siblingName) {
      formData.append(`properties[${btn.dataset.siblingName}]`, btn.dataset.siblingValue);
    }
    if (btn.dataset.preorderName) {
      formData.append(`properties[${btn.dataset.preorderName}]`, btn.dataset.preorderValue);
    }

    try {
      const res = await fetch(window.theme.routes.cart_add_url, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
        body: formData,
      });
      const data = await res.json();

      if (data.status) {
        this._showError(btn, data.description || data.message || 'Error');
        return;
      }

      btn.classList.add('is-added');
      setTimeout(() => btn.classList.remove('is-added'), 2000);

      document.dispatchEvent(new CustomEvent('theme:cart:change', { bubbles: true, detail: { cart: data } }));
      document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
    } catch (_) {
      this._showError(btn, 'Error');
    } finally {
      btn.classList.remove('is-loading');
      btn.disabled = false;
    }
  }

  _showError(btn, msg) {
    const errEl = btn.querySelector('.btn__error');
    if (errEl) {
      errEl.textContent = msg;
      btn.classList.add('has-error');
      setTimeout(() => {
        btn.classList.remove('has-error');
        errEl.textContent = ' ';
      }, 3000);
    }
  }
}

customElements.define('quick-add-inline', QuickAddInline);
